'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes');

var LightboxActionCreators = {
  showLightbox(image, sectionType) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.ENTER_LIGHTBOX,
      image: image,
      sectionType: sectionType
    });
  },

  hideLightbox() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.LEAVE_LIGHTBOX
    });
  },
};

module.exports = LightboxActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/LightboxActionCreators.js
 **/